import React from 'react';

import DeleteIcon from '@mui/icons-material/Delete';
import UndoIcon from '@mui/icons-material/Undo';

import ApplicationRow from './row';
import { EntityState } from '../../../util/enumerations';
import { Button, Card, IconButton, styled } from '@mui/material';
import { HOME_SCHOOL_ID } from '../../../constants';
import { useSchools } from '../../../contexts';
import { useApplication, useUpdateApplication } from '..';

const StyledCard = styled(Card)({
	padding: '10px',
	marginBottom: '20px',
	marginTop: '50px',
	border: '1px solid #ababab',
});

const ApplicationRows = () => {
	const { application, privileges } = useApplication();
	const { removeRow, addRow } = useUpdateApplication();
	const schools = useSchools();
	const appSchools = {
		home: schools?.find((s) => s.id === HOME_SCHOOL_ID) || null,
		exchange: application.school || null,
	};

	const renderApplicationRows = React.useMemo(
		() => (
			<div>
				{application.applicationRows.map((row, idx) => {
					if (row.state === EntityState.Removed) {
						return (
							<div style={{ textAlign: 'center' }} key={row.id}>
								<br />
								<IconButton
									style={{ margin: '10px' }}
									onClick={() =>
										removeRow(idx, EntityState.Active)
									}
								>
									<UndoIcon fontSize="large" />
								</IconButton>
							</div>
						);
					}
					return (
						<StyledCard elevation={5} key={row.id}>
							<div style={{ textAlign: 'right' }}>
								<strong>#{idx + 1}</strong>
							</div>
							<ApplicationRow
								row={row}
								schools={appSchools}
								rowIndex={idx}
							/>
							{privileges.editRows && (
								<div style={{ textAlign: 'right' }}>
									<IconButton
										color="secondary"
										aria-label="delete"
										onClick={() => removeRow(idx)}
									>
										<DeleteIcon fontSize="small" />
									</IconButton>
								</div>
							)}
						</StyledCard>
					);
				})}
			</div>
		),
		[
			application.applicationRows,
			appSchools,
			privileges.editRows,
			removeRow,
		]
	);

	return (
		<div>
			{schools && application?.school?.id ? (
				<>
					<div>{renderApplicationRows}</div>
					{privileges.editRows && (
						<div style={{ textAlign: 'center' }}>
							<Button
								color="primary"
								variant="contained"
								onClick={() => addRow()}
								sx={{ marginTop: '12px' }}
							>
								Add row
							</Button>
						</div>
					)}
				</>
			) : null}
		</div>
	);
};

export default ApplicationRows;
